import Heading, { HEADING_TYPES } from "./Heading";
import Separator from "components/shared/Separator";

const Title = ({
	title = "",
	subTitle = "",
	name = "",
	noWrap = false,
	modifier = null,
	headingType = HEADING_TYPES.h1,
	showSeparator,
}) => {
	const mainClass = "help-title";
	let classes = mainClass;
	if (name) classes += ` ${mainClass}--${name}`;

	let mainTitleClass = `${mainClass}__heading`;
	if (noWrap) mainTitleClass += ` ${mainTitleClass}--no-wrap`;
	if (modifier) mainTitleClass += ` ${mainTitleClass}--${modifier}`;

	return (
		(title || subTitle) && (
			<div className={classes}>
				{title && (
					<Heading
						type={headingType}
						className={mainTitleClass}
						content={title}
					/>
				)}
				{showSeparator && <Separator />}
				{subTitle && (
					<div
						className={`${mainClass}__subtitle`}
						dangerouslySetInnerHTML={{ __html: subTitle }}
					/>
				)}
			</div>
		)
	);
};

export default Title;
